import { keyframes, styled } from 'next-yak';

import { createPolymorphicElement } from '@xing-com/polymorphic-element';
import {
  xdlColorSkeletonPrimary,
  xdlColorSkeletonPrimaryAnimation,
  motionTimeXXL,
  motionEasingStandard,
} from '@xing-com/tokens';

// *** Animations ***
const animation = keyframes`
  0% {
    background-color: ${xdlColorSkeletonPrimaryAnimation};
  }
  100% {
    background-color: ${xdlColorSkeletonPrimary};
  }
`;

const SkeletonBaseElement = createPolymorphicElement('div');

export const SkeletonBase = styled(SkeletonBaseElement)`
  animation-direction: alternate;
  animation-duration: ${motionTimeXXL};
  animation-iteration-count: infinite;
  animation-name: ${animation};
  animation-timing-function: ${motionEasingStandard};
  background-color: ${xdlColorSkeletonPrimary};
`;
